import { RootState, useSelector } from '../redux/store'

export const useAuthHook = () => {
	return useSelector((state: RootState) => state.socketAuthStatus.isAuthenticated)
}